import { useRequest } from '@byted/hooks';
import { forumpost } from '@/typings/open.platform.forum_bff';
import { forumPostService } from '@/api/forumPost';

export const useLike = () => {
  const { run, loading } = useRequest(
    async (req: forumpost.ToggleLikeRequest) => {
      const res = await forumPostService.toggleLike(req);
      if (res.error) {
        throw new Error(res.message);
      }
    },
    {
      auto: false,
    },
  );
  return {
    toggleLike: run,
    togglingLike: loading,
  };
};
